<script>
export default {
    name: 'HeadLine',
    props: ['level', 'bold', 'size'],
    render(createElement) {
        return createElement('h' + this.level,{
            class: {
                'font-bold': this.bold,
                'text-4xl md:text-5xl' : this.size == 1,
                'text-3xl md:text-4xl' : this.size == 2,
                'text-2xl md:text-3xl' : this.size == 3,
                'text-xl md:text-2xl' : this.size == 4,
                'text-lg md:text-xl' : this.size == 5,
            },
            staticClass: 'text-support-700'
        }, this.$slots.default)
    }
}
</script>

<style>

</style>